export default "__VITE_ASSET__Y1G3F8fB__"